// extracted by mini-css-extract-plugin
export default {"description":"HomePage_description__vkWC2","descriptionBlock":"HomePage_descriptionBlock__jrarw","hr":"HomePage_hr__Axsuv","poweredBy":"HomePage_poweredBy__sXpTu"};